import React, { useState, useEffect } from "react";
import searchIcon from "./../../../../../Assets/icons/searchicon.svg";
import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import CustomTable from "../../../../customComponents/CustomTable";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import Loader from "../../../../customComponents/CustomLoader";
import { FiDownload } from "react-icons/fi";

const SalesPersonList = () => {
  const [dealers, setDealers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [city, setCity] = useState([]);
  const [filters, setFilters] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [revenue, setRevenue] = useState(0);

  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const business_partner_id = localStorage.getItem("business_partner_id");
  const userType = localStorage.getItem("UserType");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };
console.log(business_partner_id, "businessPartnerId")
  useEffect(() => {
    // fetchDealers();
    fetchCity();
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDealers(newPage);
  };

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.post(
        "/dealer/ddldealercity",
        {
          business_partner_id:
            userType === "superadmin" ? null : business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data.data; // Access the data from the response object
      const cityOptions = data.map((city) => ({
        value: city.ID,
        label: city.NAME,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };

  const fetchDealers = async (page = 0, pageSize = 10) => {
    console.log(filters, "FILTERS");
    const allfilteredData = filters;

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/salesperson/list",
        {
          orderBy: "sales_person_id desc",
          page,
          pageSize,
          // startDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
          // endDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,
          startDate: formatDate(allfilteredData?.startDate),
          endDate: formatDate(allfilteredData?.endDate),
          city_id: allfilteredData?.city ? allfilteredData?.city : null,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalActive = response?.data?.data?.total_active;
      const totalInActive = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalActive);
      setTotalInactive(totalInActive);
      // setRevenue(revenueCount)

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setDealers(formattedData);
      // toastSuccess("Dealer Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching dealer list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleKeyPress = (e) => {
    console.log("keyname", e.key);

    if (e.key === "Enter") {
      fetchDealers(0, 10, searchTerm);
    }
  };

  // Table headers
  const DEALER_TABLE_HEADERS = [
    // "Sr No.",
    "Sales Person Name",
    "Sales Person Code",
    "Email",
    "City",
    // "Created Date",
    "Status",
    "Action",
  ];

  // Key mapping for CustomTable component
  const DEALER_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    "Sales Person Code": "sales_person_code",
    "Sales Person Name": "sales_person_name",
    Email: "email_id",
    "Created Date": "created_at",
    City: "city_name",
    Status: "status",
    Action: [{ type: "edit", icon: editIcon, label: "Edit" }],
  };

    const clearFilter = () => {
      setFilterFormData({});
      setFilters({});
      fetchDealers();
    };

    useEffect(() => {
      console.log("called");

      fetchDealers();
    }, [filters]);

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      startDate: filterFormData.startDate || null,
      endDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
    });
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITSALESPERSON}`, {
      state: { data: rowData },
    });
    // console.log("rowdata", rowData)
  };

  const handleAddDealerNavigate = () => {
    navigate("/admin/manage-sales-person/sales-person/add-salesperson");
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-12 col-lg-2",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-12 col-lg-2",
    },
    {
      name: "city_id",
      label: "City",
      placeholder: "Select City",
      type: "dropdown",
      options: city,
      // required: true,
      gridClass: "col-12 col-lg-2",
    },
  ];
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchDealers();
    }
  }, [searchTerm]);

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      startDate: formatDate(allfilteredData?.startDate),
      endDate: formatDate(allfilteredData?.endDate),
      city_id: allfilteredData?.city ? allfilteredData?.city : null,
      searchText: searchTerm,
    };

    try {
      const response = await axiosInstance.post(
        "/salesperson/sales-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "sales person.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer row">
            <div className="OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2">
              <h5>Sales Person Master</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Record</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{Number(totalActive)} </h5>
                <h6>Active Record</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">
                  {Number(totalInactive)}{" "}
                </h5>
                <h6>Inactive Record</h6>
              </div>

              <div>
                <button
                  className="addcustomerbutton"
                  onClick={handleAddDealerNavigate}
                >
                  Add Sales Person
                </button>
              </div>
            </div>
          </div>

          {/* <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} /> */}
          <ListLogisticsFilters
            formConfig={PhysicalStockTakingInputs}
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleSearch}
            handleClear={clearFilter}
            // onSubmit={handleFormSubmit}
          />

          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Sales Person List</h5>
                <div className="searchinput-wrapper">
                  <input
                    type="text"
                    className="searchinput"
                    placeholder="Search By Name"
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                    onKeyPress={handleKeyPress}
                  />
                  {searchTerm ? (
                    <IoMdClose
                      size={22}
                      className="searchinput-close-icon"
                      onClick={clearSearchAndFetch}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt="Search"
                      className="searchinput-icon"
                    />
                  )}
                </div>
                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: "38px", cursor: "pointer" }}
                >
                  Export
                  <span>
                    {/* <img
                                                                        onClick={downloadExcel}
                                                                        src={DownloadSVG}
                                                                        alt="downloadSvg"
                                                                        className="downloadexcel-misreportsales"
                                                                        style={{
                                                                          // paddingTop: "9rem",
                                                                          // paddingRight: "1rem",
                                                                          
                                                                          cursor: "pointer",
                                                                          height:"24px"
                                                                        }}
                                                                      /> */}
                    <FiDownload
                      className="downloadexcel-misreportsales"
                      style={{ cursor: "pointer" }}
                      size={22}
                    />
                  </span>
                </div>
              </div>
            </div>

            <CustomTable
              data={dealers}
              headers={DEALER_TABLE_HEADERS}
              keyMapping={DEALER_KEY_MAPPING}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SalesPersonList;
